import React from 'react';
import { observer } from "mobx-react-lite";
import { FaPlusCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { ActionEditorChangeGroup, groupUndoableActionEditorChanges } from '../../../stores/undo/operation/ActionEditorSubmitChangesOp';
import styled from 'styled-components';
import { MapElementReferenceModel } from '../../../../shared/action/MapElementReferenceModel';
import { MapElementSelectionDetail } from './components/MapElementSelectionDetail';
import { MapElementFilter } from "../../../helper/MapElementFilter";
import { AiFillDelete } from "react-icons/ai";
import { ElementGroup, ElementGroupContainer } from './components/BaseElements';
const EnemyContainer = styled(ElementGroupContainer).withConfig({
  displayName: "StartFightActionDetails__EnemyContainer",
  componentId: "sc-1erokfm-0"
})(["display:flex;flex-direction:row;"]);
const IconButton = styled.div.withConfig({
  displayName: "StartFightActionDetails__IconButton",
  componentId: "sc-1erokfm-1"
})(["margin-top:-2px;float:right;color:#555555;cursor:pointer;font-size:large;&:hover{color:black;}"]);
export const StartFightActionDetails = observer(({
  action
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, action.enemies.map((enemy, index) => /*#__PURE__*/React.createElement(EnemyContainer, {
    key: index
  }, /*#__PURE__*/React.createElement(MapElementSelectionDetail, {
    name: t("action_editor.property_enemy") + " " + (index + 1),
    selectedElement: enemy,
    elementSetter: npc => {
      groupUndoableActionEditorChanges(ActionEditorChangeGroup.UnspecificGroupedNodeChanges, () => {
        action.removeEnemy(index);
        action.addEnemy(index, npc);
      });
    },
    parameterTypes: ["actions/EnemyOnMapValueModel"],
    getSelectableElements: MapElementFilter.filterEnemiesLabels
  }), /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => action.removeEnemy(index)
  }, /*#__PURE__*/React.createElement(AiFillDelete, null)))), /*#__PURE__*/React.createElement(ElementGroup, null, /*#__PURE__*/React.createElement("button", {
    onClick: () => action.addEnemy(action.enemies.length, new MapElementReferenceModel({}))
  }, /*#__PURE__*/React.createElement(FaPlusCircle, null), " ", t("action_editor.property_add_enemy"))));
});